"use client"

import {z} from "zod/v4";
import {Form} from "../../../../components/form/Form";
import {PasswordField} from "../../../../components/form/PasswordField";
import {OnSubmitResult, ZodObjectType} from "../../../../components/form/utils";
import { TextField } from "@/components/form/TextField";

interface ForgotPasswordProps<S extends ZodObjectType> {
    loading?: boolean;
    handleForgotPassword: (data: z.infer<S>) => Promise<OnSubmitResult<S>>;
}

export const forgotPasswordSchema = z.object({
  email: z.email().min(2).max(100),
});

export function ForgotPassword({ handleForgotPassword }: ForgotPasswordProps<typeof forgotPasswordSchema>) {
    return (
        <div className="space-y-6">
            <div className="text-center space-y-2">
                <h2 className="text-2xl font-bold">Forgot Password</h2>
                <p className="text-muted-foreground">Please enter your email to reset your password</p>
            </div>
            <Form
                onSubmit={handleForgotPassword}
                schema={forgotPasswordSchema}
                className="space-y-4"
                submitText={'Send Reset Link'}>
                <div className="grid grid-cols-1 gap-4">
                    <TextField name={'email'} label={'Email'}/>
                </div>
            </Form>
            <div className="text-center text-sm text-muted-foreground">
                Remembered your password? <a href="/login" className="text-primary hover:underline">Login</a>
            </div>
        </div>
    );
}

